module.exports = __webpack_public_path__ + "static/media/laforge-and-glasius.da2f1ab9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/information/about/laforge-and-glasius.jpg
// module id = 605
// module chunks = 0